
export default class Form {

	static getHolderSelectors = () => ['.form-element__form'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		holderElement.querySelectorAll('.field input').forEach(i => {
			const label = holderElement.querySelector(`[for="${i.id}"]`);
			if (i.type === 'date') {
				label.classList.add('active');
			} else {
				i.addEventListener('focus', () => label.classList.add('active'));
				i.addEventListener('blur', () => {
					!i.value && label.classList.remove('active')
				});
			}
		});
	}
}
